module.exports = __webpack_public_path__ + "img/card-2.ecaeb7b6.png";